import { LstAuthModuleOptions } from '@savvaslearning/lst-auth';
import { environment } from '../environments/environment';
import type { ButtonConfig } from './types/set-up-class';

export const lstAuthModuleOptions: LstAuthModuleOptions = {
    appId: environment.appId,
    authGatewayBaseUrl: environment.authGatewayBaseUrl,
    authContextId: environment.authContextId,
    rbsTokenScope: environment.rbsConfig.scope,
    authGatewayClientId: environment.rbsConfig.clientId,
    rbsTokenGrantType: environment.rbsConfig.grant_type,
    useUserRoleAsRbsScope: environment.useUserRoleAsRbsScope,
    ssoBaseUrl: environment.ssoBaseUrl,
    authCallbackRoute: environment.authCallbackRoute,
    includeAllOrganizations: true,
};

export interface RemoteComponentInterface {
    remoteFile: string;
    remoteName: string;
    exposedModule: string;
    moduleName: string;
    componentName: string;
}

export const EVENT_FOR_GOOGLE_CLASS_NAMESPACE = 'EVENT_FOR_GOOGLE_CLASS_WEBAPP';

export const EVENT_FROM_GOOGLE_CLASS_NAMESPACE = 'EVENT_FROM_GOOGLE_CLASS_WEBAPP';

export const EVENTS_FOR_GOOGLE_CLASS = {
    GOOGLE_ACCOUNT_LINKED: 'GOOGLE_ACCOUNT_LINKED',
    PERSIST_SESSION_FLOW_STATE: 'PERSIST_SESSION_FLOW_STATE',
};

export const EVENTS_FROM_GOOGLE_CLASS = {
    SESSION_FLOW_STATE_PERSISTED: 'SESSION_FLOW_STATE_PERSISTED',
};

export const EVENT_FOR_MODAL = {
    MODAL_SUCCESS: 'MODAL_SUCCESS',
    MODAL_FAIL: 'MODAL_FAIL',
};

export const SESSION_CONSTANTS = {
    identityId: 'savvaslearning-profile.identityId',
    rbsToken: 'savvaslearning-profile.token',
    primaryOrgId: 'savvaslearning-profile.OrganizationId1',
};

export const DEFAULT_LOCALE = 'en';

export const NEXT_BUTTON_CONFIG_DEFAULT: ButtonConfig = {
    enabled: false,
    visible: true,
};

export const BACK_BUTTON_CONFIG_DEFAULT: ButtonConfig = {
    enabled: true,
    visible: true,
};

export const CANCEL_BUTTON_CONFIG_DEFAULT: ButtonConfig = {
    enabled: true,
    visible: true,
};

export const IMPORT_CLASS_TRANSLATE_KEYS = {
    googleSelectLabel: 'googleSelectLabel',
    googleClassPlaceholder: 'googleClassPlaceholder',
    organizationSelectLabel: 'organizationSelectLabel',
    organizationPlaceholder: 'organizationPlaceholder',
    noClasses: 'noClasses',
    loadingSelections: 'loadingSelections',
};

export const LINK_CLASS_TRANSLATE_KEYS = {
    googleSelectLabel: 'googleSelectLabel',
    googleClassPlaceholder: 'googleClassPlaceholder',
    realizeClassSelectLabel: 'realizeClassSelectLabel',
    realizeClassPlaceholder: 'realizeClassPlaceholder',
    noClasses: 'noClasses',
    loadingSelections: 'loadingSelections',
    noLinkingHeader: 'noLinkingHeader',
    noGoogleClassesLinkMessage: 'noGoogleClassesLinkMessage',
    programsAddedMessage: 'programsAddedMessage',
    noRealizeClassesLinkMessage: 'noRealizeClassesLinkMessage',
    visitSetupText: 'visitSetupText',
    setUpClassGuideLinkText: 'setUpClassGuideLinkText',
    forMoreInfoText: 'forMoreInfoText',
    tempNoLinkingHeader: 'tempNoLinkingHeader',
    tempProgramAssignedLabel: 'tempProgramAssignedLabel',
    tempProgramAssignedText: 'tempProgramAssignedText',
    tempProgramAssignedTextBeforeLink: 'tempProgramAssignedTextBeforeLink',
    tempProgramAssignedLinkText: 'tempProgramAssignedLinkText',
    tempProgramAssignedTextAfterLink: 'tempProgramAssignedTextAfterLink',
    tempMissingGoogleClassesLabel: 'tempMissingGoogleClassesLabel',
    tempMissingGoogleClassesText: 'tempMissingGoogleClassesText',
    tempPendingAutoRosteringLabel: 'tempPendingAutoRosteringLabel',
    tempPendingAutoRosteringText: 'tempPendingAutoRosteringText',
    tempAdminManagedProgramsLabel: 'tempAdminManagedProgramsLabel',
    tempAdminManagedProgramsText: 'tempAdminManagedProgramsText',
    tempVisitSetupText: 'tempVisitSetupText',
    tempSetUpClassGuideLinkText: 'tempSetUpClassGuideLinkText',
    tempForMoreInfoText: 'tempForMoreInfoText',
};

export const CLASS_SETTINGS_LINK_TRANSLATE_KEYS = {
    noLinkedClassText: 'noLinkedClassText',
    googleClassroomText: 'googleClassroomText',
    linkClassButtonText: 'linkClassButtonText',
    disconnectClassButtonText: 'disconnectClassButtonText',
    linkClassErrorToastText: 'linkClassErrorToastText',
    disconnectClassErrorToastText: 'disconnectClassErrorToastText',
};

export const LINK_CLASS_MODAL_TRANSLATE_KEYS = {
    headerLink: 'linkClassModal.headerLink',
    headerDisconnect: 'linkClassModal.headerDisconnect',
    classMappingNoClassesText: 'linkClassModal.noGoogleClassesLinkText',
    classMappingHasClassesText: 'linkClassModal.hasGoogleClassesLinkText',
    classMappingDisconnectText: 'linkClassModal.classMappingDisconnectText',
    programSectionText: 'linkClassModal.bodyProgramSectionText',
    acknowledgementsCheckboxLabel: 'linkClassModal.acknowledgements.checkboxLabel',
    acknowledgementsLinkItemOne: 'linkClassModal.acknowledgements.linkItemOne',
    acknowledgementsLinkItemTwo: 'linkClassModal.acknowledgements.linkItemTwo',
    acknowledgementsDisconnectImportedItemOne: 'linkClassModal.acknowledgements.disconnectImportedItemOne',
    acknowledgementsDisconnectImportedItemTwo: 'linkClassModal.acknowledgements.disconnectImportedItemTwo',
    acknowledgementsDisconnectLinkedItemOne: 'linkClassModal.acknowledgements.disconnectLinkedItemOne',
    acknowledgementsDisconnectLinkedItemTwo: 'linkClassModal.acknowledgements.disconnectLinkedItemTwo',
    acknowledgementsDisconnectItemCommon: 'linkClassModal.acknowledgements.disconnectItemCommon',
    confirmLabelLink: 'linkClassModal.confirmLabelLink',
    confirmLabelDisconnect: 'linkClassModal.confirmLabelDisconnect',
    closeLabel: 'linkClassModal.closeLabel',
    cancelLabel: 'linkClassModal.cancelLabel',
    classConnectionsAriaLabel: 'linkClassModal.classConnectionsAriaLabel',
    realizeClassLabel: 'linkClassModal.realizeClassLabel',
    googleClassLabel: 'linkClassModal.googleClassLabel',
    googleClassPlaceholder: 'googleClassPlaceholder',
    noGoogleClassesAvailable: 'linkClassModal.noGoogleClassesAvailable',
    linkingIconAriaLabel: 'linkClassModal.linkingIconAriaLabel',
    disconnectingIconAriaLabel: 'linkClassModal.disconnectingIconAriaLabel',
    programSectionEmptyState: 'linkClassModal.programSectionEmptyState',
    programSectionEmptyStateLink: 'linkClassModal.programSectionEmptyStateLink',
};

export enum GoogleClassFlow {
    Import = 'google-class-import',
    Link = 'google-class-link',
    ClassSettingsLink = 'google-class-settings-link',
}

export const MOCK_REALIZE_CLASSES = [
    { label: 'Realize Class 1', identifier: 'realize-class-1' },
    { label: 'Realize Class 2', identifier: 'realize-class-2' },
    { label: 'Realize Class 3', identifier: 'realize-class-3' },
];

export const SET_UP_CLASS_GUIDE_URL = environment.classGuideUrl;

export const FMS_ATTRIBUTES_KEY = 'realize.fmsAttributes';

export const GOOGLE_CLASS_INTEGRATION_FMS_FLAG = 'show.google.classroom.integration';

export const GOOGLE_INTEGRATION_ID = 'google';

export const GOOGLE_INTEGRATION_TYPE = 'google';

export const PERSIST_SESSION_FLOW_STATE = 'PERSIST_SESSION_FLOW_STATE';
